import React, { useEffect } from "react";
import { Grid } from "@mui/material";
import EditTable from "../../../components/Components/GuestListTable";
import { useQuery } from "react-query";
import { getGuestList } from "../mutations/TransactionsMutation";
import Loader from "../../../components/Components/Loader";

function GuestTransaction() {
  const currentTimestamp = Date.now();

  const currentDate = new Date(currentTimestamp);

  const formattedDate = currentDate.toISOString().slice(0, 10);

  const { data: guestData, isLoading } = useQuery(
    "guest-transactions",
    () => getGuestList(formattedDate),
    {
      refetchOnMount: true,
    }
  );

  if (isLoading) return <Loader />;

  return (
    <Grid container justifyContent={"center"}>
      <Grid item textAlign={"center"}>
        <h4>Guests Transactions</h4>
      </Grid>
      <Grid item xs={12}>
        <EditTable tableData={guestData ?? []} />
      </Grid>
    </Grid>
  );
}

export default GuestTransaction;
